import WidgetsOutlined from "@mui/icons-material/WidgetsOutlined";
import type { FC } from "react";

import { HotKeyTooltip } from "~/components/common/HotKeyToolTip";
import { Button } from "~/ui/Button";

import { usePropertiesPane } from "../easel/properties-pane/usePropertiesPane";

export const ToggleComponentsPaneButton: FC = () => {
	const hotkeyName = "open-components-tab";
	const { togglePane, paneState } = usePropertiesPane();

	return (
		<HotKeyTooltip hotkeyName={hotkeyName}>
			<Button
				size="sm"
				preset="quaternary"
				onClick={() =>
					togglePane({ pane: "components", metadata: { isInitiatedByUser: true } })
				}
				toggled={paneState.pane === "components"}
				data-testid="components-tab-button"
				startIcon={<WidgetsOutlined />}
			>
				Insert
			</Button>
		</HotKeyTooltip>
	);
};
